// extracted by mini-css-extract-plugin
export var borderRadius = "_4h-4";
export var large = "_4h-3";
export var logoContainer = "_4h-0";
export var nameLogo = "_4h-2";
export var small = "_4h-1";